import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '../../axios/axiosInstance';
import { withZBSignature } from '../../services/security/zbSignature';

export const useRegisterUser = () =>
  useMutation(async ({ params }) => {
    const signedParams = await withZBSignature(params);
    const { data } = await axiosInstance.post('/api/auth/member/register', { ...signedParams });
    return data;
  });
